<template>
  <form ref="formReceivers">
    <div class="emd-panel">
      <div class="emd-panel__section">
        <div class="emd-panel__block">
          <div class="el-chunk">
            <h2 class="emd-text _color_default _type_caption">
              {{ $t('title') }}
            </h2>
          </div>
        </div>
        <div class="emd-panel__block">
          <div class="el-chunk">
            <div class="emd-form-group">
              <label
                class="emd-label _required"
                for="name"
                >{{ $t('name') }}</label
              >
              <input
                :disabled="disabled"
                class="emd-input"
                id="name"
                data-testid="name"
                v-model="form.name"
                @input="$v.form.name.$touch"
                :class="{
                  _state_error: $v.form.name.$invalid && $v.form.name.$dirty
                }"
              />
            </div>
            <div class="emd-form-group">
              <label
                class="emd-label _required"
                for="email"
                >{{ $t('email') }}</label
              >
              <input
                :disabled="disabled"
                class="emd-input"
                id="email"
                data-testid="email"
                v-model="form.email"
                @input="$v.form.email.$touch"
                :class="{
                  _state_error: $v.form.email.$invalid && $v.form.email.$dirty
                }"
              />
            </div>
            <div class="emd-form-group">
              <label
                class="emd-label _required"
                for="phone"
                >{{ $t('phone') }}</label
              >
              <the-mask
                :disabled="disabled"
                :masked="false"
                data-testid="phone"
                class="emd-input"
                :mask="['(##) ####-####', '(##) #####-####']"
                type="tel"
                v-model="form.phone"
                @input="$v.form.phone.$touch"
                :class="{
                  _state_error: $v.form.phone.$invalid && $v.form.phone.$dirty
                }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { email, minLength, maxLength, required } from 'vuelidate/lib/validators'
import PhysicalWorldFormDTO from '../PhysicalWorldFormDTO'
import { TheMask } from 'vue-the-mask'

export default {
  name: 'FormReceivers',
  components: {
    TheMask
  },
  props: {
    initialValues: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        phone: ''
      }
    }
  },
  validations () {
    return {
      form: {
        name: {
          required
        },
        email: {
          required,
          email
        },
        phone: {
          required,
          minLength: minLength(10),
          maxLength: maxLength(11)
        }
      }
    }
  },
  mounted () {
    this.form = { ...this.form, ...this.initialValues }
  },
  methods: {
    submitEmitter () {
      this.$v.form.$touch()
      const isInvalid = this.$v.form.$invalid

      if (!isInvalid) {
        new PhysicalWorldFormDTO().addItem({ recipient: this.form })
      }

      return new PhysicalWorldFormDTO().setError(isInvalid)
    }
  }
}
</script>

<i18n>
    {
        "pt-BR": {
            "title": "Dados do Recebedor",
            "name": "Nome",
            "email": "Email",
            "phone": "Telefone"
        },
        "en-US": {
            "title": "Recipient Data",
            "name": "Name",
            "email": "Email",
            "phone": "Phone"
        }
    }
</i18n>
